import { JwtConfig } from '@auth0/angular-jwt';

// Valores default apenas como fallback; URL real deve vir de window.__env.apiUrl injetado em runtime.
const protocol = 'https';
const server = 'api-ext-ws3.dev.wilsonsons.com.br';
const storage = localStorage;
const jwtKey = 'access_token';
const analyticsId = 'G-H0LZL3BQPX';

const defaultApiUrl = `${protocol}://${server}/api/`;
const runtimeApiUrl = window.__env?.apiUrl || defaultApiUrl;

if (window && !window.__env?.apiUrl) {
  // Ajuda de diagnóstico em ambientes onde o script env.js não carregou.
  console.warn(
    '[env] window.__env.apiUrl não definido; usando fallback build-time:',
    defaultApiUrl,
  );
}

const resolveAllowedDomain = () => {
  try {
    return new URL(runtimeApiUrl).host;
  } catch {
    // Fallback strips protocol and path when URL parsing fails.
    return runtimeApiUrl.replace(/^https?:\/\//, '').split('/')[0];
  }
};

const allowedDomain = resolveAllowedDomain();
// Lista adicional de domínios aceitos (multi-ambiente / migração / dev vs prod)
const extraAllowedDomains = [
  'apidev-ws3.wilsonsons.com.br',
  'api-ext-ws3.dev.wilsonsons.com.br',
];

declare global {
  interface Window {
    __env: any;
  }
}

export const environment = {
  production: false,
  apiUrl: runtimeApiUrl,
  gaId: window.__env?.gaId || analyticsId,
};

export const tokenGetter = () => storage.getItem(jwtKey);
export const tokenSetter = (token: string | null) => {
  if (token) storage.setItem(jwtKey, token);
  else storage.removeItem(jwtKey);
};

export const jwtConfig: JwtConfig = {
  tokenGetter,
  // Garante remoção de duplicatas, caso allowedDomain já esteja na lista extra
  allowedDomains: Array.from(new Set([allowedDomain, ...extraAllowedDomains])),
  disallowedRoutes: [
    `${runtimeApiUrl}users/login`,
    `${runtimeApiUrl}users/forgot-password`,
  ],
};
